export const EXCMDAILYPLAN_DELETE_RESET = 'EXCMDAILYPLAN_DELETE_RESET'
export const EXCMDAILYPLAN_DELETE_SET_ERROR = 'EXCMDAILYPLAN_DELETE_SET_ERROR'
export const EXCMDAILYPLAN_DELETE_SET_DELETED = 'EXCMDAILYPLAN_DELETE_SET_DELETED'
export const EXCMDAILYPLAN_DELETE_TOGGLE_LOADING = 'EXCMDAILYPLAN_DELETE_TOGGLE_LOADING'
